<div>
    <div class="col-sm-12">
        <kendo-editor 
            class="kendo-editor-wrapper plainTxt-wrapper"
            [(value)]="plainTxtContent"
            (valueChange)="onEditorChange($event)"
            [style.height.px]="400">
        </kendo-editor>
    </div>
</div>
